export default function registerActivityLinkablePicker(Alpine) {
  Alpine.data("activityLinkablePicker", ({ endpoint, initialType, initialId, initialLabel }) => ({
    endpoint,
    query: "",
    selected: initialId ? { type: initialType, id: initialId, label: initialLabel } : null,
    results: [],
    open: false,
    loading: false,
    focusedIndex: -1,
    _searchSeq: 0,
    _debounceTimer: null,

    get selectedType() {
      return this.selected?.type || "";
    },
    get selectedId() {
      return this.selected?.id || "";
    },

    debouncedSearch() {
      clearTimeout(this._debounceTimer);
      this._debounceTimer = setTimeout(() => this.search(), 250);
    },

    async search() {
      if ((this.query || "").trim().length < 2) {
        this.results = [];
        this.open = false;
        return;
      }
      const seq = ++this._searchSeq;
      this.loading = true;
      try {
        const url = `${this.endpoint}?q=${encodeURIComponent(this.query)}`;
        const resp = await fetch(url, { headers: { Accept: "application/json" } });
        if (!resp.ok) {
          this.results = [];
          return;
        }
        const data = await resp.json();
        if (seq !== this._searchSeq) return;
        this.results = data;
        this.focusedIndex = data.length > 0 ? 0 : -1;
        this.open = true;
      } finally {
        if (seq === this._searchSeq) this.loading = false;
      }
    },

    groupedResults() {
      const groups = { Customer: [], Opportunity: [], Contact: [], Contract: [] };
      for (const r of this.results) {
        if (groups[r.type]) groups[r.type].push(r);
      }
      return groups;
    },

    select(r) {
      this.selected = { type: r.type, id: r.id, label: r.title };
      this.query = "";
      this.results = [];
      this.open = false;
      this.focusedIndex = -1;
      this.$dispatch("linkable-changed", { selected: true });
    },

    clear() {
      this.selected = null;
      this.query = "";
      this.results = [];
      this.open = false;
      this.$dispatch("linkable-changed", { selected: false });
    },

    moveFocus(delta) {
      if (!this.open) {
        this.open = true;
        if (this.results.length === 0) this.search();
        return;
      }
      if (this.results.length === 0) return;
      this.focusedIndex = (this.focusedIndex + delta + this.results.length) % this.results.length;
    },

    selectFocused() {
      const r = this.results[this.focusedIndex];
      if (r) this.select(r);
    }
  }));
}
